/* eslint-disable radix */
import api from "@/services/api";
import GdprInput from "./GdprInput/GdprInput.vue";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            premiums: [],
            costLimit: 0,
            costLimitMaxCombined: 300,
            oldCostLimit: 0,
            costLimitRoaming: 0,
            oldCostLimitRoaming: 0
        };
    },

    components: {
        GdprInput
    },

    computed: {
        ...mapGetters({
            user: "user/user",
            contract: "contract/contract"
        }),

        dirtyCostLimit() {
            return parseInt(this.costLimit) !== parseInt(this.oldCostLimit);
        },

        dirtyCostLimitRoaming() {
            return parseInt(this.costLimitRoaming) !== parseInt(this.oldCostLimitRoaming);
        }
    },

    methods: {
        /**
         * Get Premium states on mounted
         */
        getPremiumStates() {
            // This fixes sending api call before app is mounted on reload
            if (!this.contract.clickedContract.phoneNumber) {
                return;
            }
            this.$Progress.start();

            api.get("/api/get-settings")
                .then(response => {
                    this.premiums = response.data.body;

                    this.costLimit = Math.ceil(this.premiums.inputs.find(x => x.key === 'costLimit').value);
                    this.costLimitRoaming = Math.ceil(
                        this.premiums.inputs.find(x => x.key === 'costRoamingLimit').value
                    );

                    this.oldCostLimit = this.costLimit;
                    this.oldCostLimitRoaming = this.costLimitRoaming;

                    this.$Progress.finish();
                })
                .catch(() => {
                    this.$toast.error(this.$i18n.t("messages.error"));
                    this.$Progress.finish();
                });
        },

        changeSetting(index, oldValue) {
            this.$Progress.start();

            this.premiums.checkboxes[index] = !oldValue;

            api.post("/api/update-settings", {
                type: index,
                enabled: !oldValue
            })
                .then(response => {
                    this.$Progress.finish();
                })
                .catch(() => {
                    this.$toast.error(this.$i18n.t("messages.error"));
                    this.$Progress.finish();
                });
        },

        changeRoamingSetting(index, oldValue) {
            this.$Progress.start();

            this.premiums.roaming[index] = !oldValue;

            api.post("/api/update-settings", {
                type: index,
                enabled: !oldValue
            })
                .then(response => {
                    this.$Progress.finish();
                })
                .catch(() => {
                    this.$toast.error(this.$i18n.t("messages.error"));
                    this.$Progress.finish();
                });
        },

        submitCostLimit() {
            if (parseInt(this.oldCostLimitRoaming) + parseInt(this.costLimit) > this.costLimitMaxCombined) {
                this.$toast.error(this.$i18n.t('settings.costLimitMaxCombined'));
                return true;
            }

            this.$Progress.start();

            api.post("/api/update-settings", {
                type: 'costLimit',
                limit: this.costLimit
            })
                .then(response => {
                    this.$Progress.finish();
                    this.oldCostLimit = this.costLimit
                })
                .catch((error) => {
                    if (error.response.data.body.hasOwnProperty('validation_errors') && error.response.data.body.validation_errors.hasOwnProperty('limit')) {
                        this.$toast.error(error.response.data.body.validation_errors.limit.toString());
                    } else {
                        this.$toast.error(this.$i18n.t("messages.error"));
                    }
                    this.$Progress.finish();
                });
        },
        submitCostLimitRoaming() {
            if (parseInt(this.costLimitRoaming) + parseInt(this.oldCostLimit) > this.costLimitMaxCombined) {
                this.$toast.error(this.$i18n.t('settings.costLimitMaxCombined'));
                return true;
            }

            this.$Progress.start();

            api.post("/api/update-settings", {
                type: 'costRoamingLimit',
                limit: this.costLimitRoaming
            })
                .then(response => {
                    this.oldCostLimitRoaming = this.costLimitRoaming
                    this.$Progress.finish();
                })
                .catch((error) => {
                    if (error.response.data.body.hasOwnProperty('validation_errors') && error.response.data.body.validation_errors.hasOwnProperty('limit')) {
                        this.$toast.error(error.response.data.body.validation_errors.limit.toString());
                    } else {
                        this.$toast.error(this.$i18n.t("messages.error"));
                    }
                    this.$Progress.finish();
                });
        }
    },

    /**
     * Listen for object changed for clicked contract
     */
    watch: {
        "contract.clickedContract.phoneNumber": {
            handler() {
                this.getPremiumStates();
            },
            deep: true
        }
    },

    mounted() {
        this.getPremiumStates();
    }
};
